import React from 'react'

import { LazyComponent } from '@/components/lazyComponent/lazyComponent'
import { usePixieWorldAuthContext } from '@/shared/auth/pixieWorldAuthContext'
import { pxToRem } from '@/shared/styles/themes'
import { Box, styled } from '@mui/material'

import { BottomTabBar, bottomTabBarHeight } from './BottomTabBar/BottomTabBar'
import { FooterFragment, FooterFragmentProps } from './FooterFragment'
import { GlobalContextType } from './global/layout'
import { HeaderFragment, HeaderFragmentProps } from './HeaderFragment'

export type LayoutProps = {
  globals?: GlobalContextType
  children?: React.ReactNode
  noCategoryBrowser?: boolean
  noFooter?: boolean
  noFooterCopyRight?: boolean
  fullWidth?: boolean
  slotProps?: {
    footer?: Partial<FooterFragmentProps>
    header?: Partial<HeaderFragmentProps>
  }
}


export const Layout: React.FC<LayoutProps> = ({ globals, noFooter, noFooterCopyRight, noCategoryBrowser, fullWidth, slotProps, children }) => {
  const { isAuthenticating } = usePixieWorldAuthContext()

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <HeaderFragment header={globals?.header} {...slotProps?.header} />
        {noCategoryBrowser && <StyledDivider />}

        <main id="main" style={{ flex: '1', display: fullWidth ? 'flex' : 'block', flexDirection: 'column' }}>
          {children}
        </main>
        <div id="mobile-slider-portal" />
        <div id="browser-menu" />
        <div id="modal" />

        {noFooter && !noFooterCopyRight && < StyledDivider />}
        {!noFooterCopyRight && <LazyComponent>
          <FooterFragment lightweight={noFooter} footer={globals?.footer} {...slotProps?.footer} />
        </LazyComponent>}
        <StyledBottomTabSpacer />
        <BottomTabBar />
      </Box>
      {isAuthenticating && <StyledLoadingScreen>Authenticating...</StyledLoadingScreen>}
    </>
  )
}

const StyledBottomTabSpacer = styled('div')`
  height: calc(${pxToRem(bottomTabBarHeight)} + env(safe-area-inset-bottom, 0px));

  ${props => props.theme.breakpoints.up('md')} {
    display: none;
  }
`

const StyledDivider = styled('div')`
  border-bottom: 1px solid ${(props) => props.theme.palette.divider};
  margin: 0;
`

const StyledLoadingScreen = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  font-size: 2em;
`